export default "__VITE_ASSET__33f5a4b5__"